import React from "react";

const ProjectsPageCMS = () => (
  <div className="page-content">
    <a
      className="dev"
      target="_blank"
      href="https://fortunefilmworks.ca/"
      rel="noopener noreferrer"
    >
      <img src="/img/FF_logo.png" alt="Client Site" />
      <p>Fortune Filmworks</p>
    </a>
    <a
      className="dev"
      target="_blank"
      href="http://bisci.ca/"
      rel="noopener noreferrer"
    >
      <img src="/img/bisci.png" alt="Client Site" />
      <p>Blackfoot Industrial Supply Centre Inc.</p>
    </a>
    <a
      className="dev"
      target="_blank"
      href="http://inspirationstation.ca/"
      rel="noopener noreferrer"
    >
      <img src="/img/client2.png" alt="Client Site" />
      <p>Inspiration Station</p>
    </a>
    <a
      className="dev"
      target="_blank"
      href="https://www.ottawasewing.com/"
      rel="noopener noreferrer"
    >
      <img src="/img/client1.png" alt="Client Site" />
      <p>Ottawa Sewing Centre</p>
    </a>
  </div>
);

export default ProjectsPageCMS;
